// extracted by mini-css-extract-plugin
export default {"resetButton":"UgeflOY","overlay":"EyvLZNH"};